var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 96",
    id: "Zoho--Streamline-Svg-Logos",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Zoho Streamline Icon: https://streamlinehq.com\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e79225",
    d: "M94.9999 38.71v22.2882l-3.0844 3.011v-21.811l3.0844-3.4882Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff16d",
    d: "m74.7863 38.7283-3.1945 3.4699.1652.2204 20.0301-.0735.1836-.1469L95 38.71l-20.2137.0183Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M91.9707 42.1982H71.5918v21.8293h20.3789V42.1982Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M88.8681 50.0557c-.4039-1.0098-1.0098-1.9278-1.7993-2.7172-.7527-.7711-1.5972-1.3586-2.5519-1.7442-.9363-.3855-1.9461-.5875-3.0477-.5875-1.1015 0-2.1296.202-3.066.5875-.9547.3856-1.7992.9731-2.5519 1.7442-.7895.7894-1.377 1.7074-1.7809 2.7172-.4039 1.0097-.5875 2.1113-.5875 3.323 0 1.175.202 2.2766.6059 3.3047.4039 1.0281.9914 1.9461 1.7808 2.7539.7344.7527 1.5789 1.3219 2.5153 1.7074.9363.3856 1.9828.5875 3.1027.5875 1.0832 0 2.093-.2019 3.0293-.5875.9363-.3855 1.7992-.9547 2.5519-1.7074.7895-.8078 1.3954-1.7258 1.7993-2.7355.4039-1.0098.6058-2.1297.6058-3.3047 0-1.2301-.2019-2.3317-.6058-3.3414Zm-4.2043 7.1968c-.7895.9364-1.836 1.4137-3.1946 1.4137-1.3586 0-2.4234-.4773-3.2129-1.4137-.7894-.9363-1.175-2.2398-1.175-3.8921 0-1.6891.404-2.9926 1.175-3.9473.7895-.9547 1.836-1.4137 3.2129-1.4137 1.3586 0 2.4051.4774 3.1946 1.4137.7711.9547 1.175 2.2582 1.175 3.9473 0 1.6523-.3856 2.9558-1.175 3.8921Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#009ada",
    d: "M69.5907 36.8936v.1101l2.6071 20.0301-1.5239 4.2226-.2019-.1468-2.6805-19.2039.0551-.2571 1.6707-4.6449.0734-.1101Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#91c9ed",
    d: "m49.5241 39.6842 20.0668-2.7906-1.689 4.8101-.2387.257-18.7633 2.7539.0918-3.4332.5324-1.5972Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m67.9017 41.7041 2.7722 19.5527-19.773 2.7723-2.6621-18.8918 1.1566-.8996 18.5063-2.5336Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M64.542 45.4492c-.0918-.6058-.2938-1.0648-.6242-1.3769-.2754-.2387-.6059-.3672-.9914-.3672-.0918 0-.202 0-.3121.0183-.5141.0735-.8997.3121-1.1383.6977-.1836.2754-.2571.6242-.2571 1.0281 0 .1469.0184.3121.0368.4774l.716 5.0855-5.6914.8445-.716-5.0855c-.0918-.5875-.2938-1.0465-.6243-1.3586-.2754-.257-.6058-.3855-.973-.3855-.0918 0-.1836 0-.2754.0183-.5324.0735-.9363.3121-1.1934.6977-.1836.2754-.257.6242-.257 1.0281 0 .1469.0184.3121.0367.4957l1.9461 13.2371c.0918.6059.2938 1.0649.661 1.377.2754.2386.6058.3488 1.0097.3488.1102 0 .2203 0 .3305-.0184.4957-.0734.8629-.3121 1.1016-.6976.1652-.2754.2386-.6059.2386-.9914 0-.1469-.0183-.3121-.0367-.4774l-.7894-5.2324 5.6914-.8445.7894 5.2324c.0918.6059.2938 1.0648.6426 1.3586.2754.2387.6059.3672.9914.3672.0918 0 .202 0 .3121-.0184.5141-.0734.8996-.3121 1.1383-.6976.1652-.2754.257-.6059.257-1.0098 0-.1469-.0183-.3121-.0367-.4774L64.542 45.4492Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#66bf6b",
    d: "m30.7424 31.7891-7.1418 16.964.973 7.4539.0551-.0183 8.0231-18.0473-.0368-.3855-1.7257-5.7282-.1469-.2386Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#98d0a0",
    d: "m30.7422 31.7891 1.8543 6.2238.0367.1285 17.6617 7.9129.0551-.0367-1.5055-5.9485-18.1023-8.28Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m32.5958 38.0127 17.7535 8.0047-8.023 18.1941-17.7535-8.0047 8.023-18.1941Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M44.9707 47.4867c-.3855-1.0281-.918-1.9094-1.6156-2.6437-.6977-.7344-1.5422-1.3219-2.5336-1.7442-.9914-.4222-1.9828-.6242-2.9926-.6242h-.0551c-1.0281 0-2.0379.2387-3.0293.6793-1.0465.459-1.9461 1.0832-2.7172 1.9094-.7711.8078-1.3953 1.7992-1.8726 2.9375-.4774 1.1199-.7344 2.2582-.7895 3.3781v.3856c0 .9914.1653 1.9644.5141 2.9191.3672 1.0098.8996 1.8727 1.5973 2.607.6976.7344 1.5605 1.3219 2.5886 1.7442.9731.4222 1.9645.6242 2.9743.6242h.0183c1.0098 0 2.0195-.2203 3.0109-.6426 1.0465-.459 1.9645-1.1016 2.7356-1.9277.7711-.8078 1.4137-1.7809 1.891-2.9192.4774-1.1382.7344-2.2582.7895-3.3781v-.3305c.0183-1.0097-.1469-2.0011-.5141-2.9742Zm-3.5434 5.2875c-.6609 1.5789-1.5605 2.6621-2.6437 3.2496-.5875.3121-1.1934.4774-1.7992.4774-.5324 0-1.1016-.1285-1.6707-.3672-1.2485-.5324-2.0196-1.377-2.35-2.5887-.1102-.4039-.1653-.8262-.1653-1.2668 0-.8812.2203-1.8543.661-2.9008.6793-1.6156 1.5789-2.7172 2.6621-3.323.5875-.3305 1.1933-.4774 1.7992-.4774.5508 0 1.1016.1286 1.6891.3672 1.23.5325 2.0011 1.377 2.3316 2.5887.1102.3856.1652.8078.1652 1.2484 0 .918-.2203 1.9094-.6793 2.9926Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#760d16",
    d: "m22.1869 34.6709 2.9008 19.4242-1.3219 6.8297-.1836-.2387-2.8273-18.7632v-.3672l1.2484-6.5543.1836-.3305Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef463e",
    d: "m1 44.7135 1.37695-6.8664 19.80975-3.1762-1.3402 6.9949v.459L1.23867 44.8971 1 44.7135Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m20.8465 41.666 2.9191 19.259-19.60779 3.066L1 44.7137l19.8465-3.0477Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M18.7352 57.859c-.1469-.1836-.3672-.3121-.6243-.4039-.257-.0918-.5691-.1285-.9546-.1285-.3489 0-.7528.0367-1.1934.1101l-5.1774.8813c.0551-.4039.2571-.918.6059-1.5606.3856-.716.9731-1.5789 1.7258-2.5703.257-.3488.459-.6059.6058-.7894.0918-.1286.2387-.2938.4223-.5325 1.1934-1.5605 1.9094-2.8273 2.2031-3.8187.1653-.5692.2571-1.1383.2938-1.7074.0183-.1653.0183-.3121.0183-.459 0-.4039-.0367-.8078-.1101-1.2117-.0551-.3672-.1469-.661-.2754-.8996-.1285-.2387-.2754-.4223-.459-.5325-.2019-.1285-.514-.1836-.8996-.1836-.3121 0-.6976.0368-1.1566.1102L7.77461 45.191c-.71602.1285-1.2668.3305-1.59727.661-.27539.257-.4039.5875-.4039.9546 0 .0918 0 .202.01836.3122.09179.514.34882.8812.77109 1.0648.25703.1102.55078.1652.91797.1652.23867 0 .51406-.0183.80781-.0734l4.99373-.8813c0 .0918.0184.1836.0184.2571 0 .3121-.0551.6242-.1653.9179-.1468.4223-.514 1.0098-1.1199 1.7625-.1652.202-.4222.5325-.7711.9547-1.35856 1.634-2.31325 3.0293-2.90075 4.186-.42227.8078-.69766 1.5789-.86289 2.3683-.0918.459-.14688.8813-.14688 1.3035 0 .2938.01836.5875.07344.8629.07344.4039.16524.7344.29375.9914.12852.2571.31211.459.51406.5692.20196.1101.47735.1469.88125.1469.49571 0 1.17502-.0735 2.03792-.2204l5.4344-.9363c.9546-.1652 1.6339-.4039 2.0195-.716.3121-.257.4773-.6059.4773-1.0098 0-.1101-.0183-.2203-.0367-.3304-.0367-.2387-.1285-.459-.2937-.6426Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1090.45,
    x2: 1090.45,
    y1: 73.44,
    y2: 2159.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#ffe513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdb924"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 149.476,
    x2: 2186.72,
    y1: 342.962,
    y2: 1995.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#008cd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00649d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1313.44,
    x2: 1313.44,
    y1: 765.785,
    y2: 2593.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26a146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008a52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 996.629,
    x2: 1299.27,
    y1: 224.905,
    y2: 2124.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d92231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba2234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoho);
export default __webpack_public_path__ + "static/media/zoho.77c142d8a62fdfd947bec0f08bf4c9b6.svg";
export { ForwardRef as ReactComponent };